import { useRef, useState } from 'react';
import { Button } from '@mui/joy';
import { APIStopAdditional } from '../../api';
import AdditionalStopDialog from './AdditionalStopDialog';
import { additionalId, hasAdditional } from './additionalActionsUi';

export default function AdditionalStopButton({ event, token, onChanged, disabled = false }) {
  const [open, setOpen] = useState(false), [busy, setBusy] = useState(false), [error, setError] = useState('');
  const expected = useRef(null), flight = useRef(false);
  if (!hasAdditional(event)) return null;
  const confirm = async reason => {
    if (flight.current) return;
    flight.current = true; setBusy(true); setError('');
    try {
      const res = await APIStopAdditional(event.id, expected.current, reason, token);
      if (res?.status !== 'ok') setError(res?.message || 'Не удалось снять дозамер');
      else { setOpen(false); onChanged?.(res.event); window.dispatchEvent(new Event('surveyor-additional-changed')); }
    } catch (_) { setError('Ошибка связи. Обновите карточку перед повтором.'); }
    finally { flight.current = false; setBusy(false); }
  };
  return <>
    <Button color="danger" variant="outlined" disabled={disabled || busy} onClick={() => {
      expected.current = additionalId(event); setError(''); setOpen(true);
    }}>Снять дозамер</Button>
    <AdditionalStopDialog open={open} busy={busy} error={error} onCancel={() => setOpen(false)} onConfirm={confirm} />
  </>;
}